import type { Colors, DefaultTheme } from 'styled-components';
import { darkColors, mapDarkTheme } from './DarkTheme';

const colors: Colors = {
  ...darkColors,
  primary: {
    lighten: '#33e3ff',
    default: '#00dcff',
    dim: 'rgba(0,220,255,0.4)',
    mute: 'rgba(0,220,255,0.1)',
  },
  gray: {
    '100': '#ffe',
    '000': '#03060b',
    '010': '#0a0d11',
    main: '#0f1b32',
    '020': '#1d283d',
    '030': '#2b3648',
    '040': '#3a4453',
    '050': '#414a59',
    '060': '#4b5461',
    '070': '#5b636e',
    '080': '#878d90',
    '090': '#a8acaa',
  },
  green: {
    lighten: '#00f07c',
    default: '#00bd62',
    dim: 'rgba(0,189,98,0.4)',
    mute: 'rgba(0,189,98,0.1)',
  },
  red: {
    lighten: '#ff5757',
    default: '#ff2424',
    dim: 'rgba(255,36,36,0.4)',
    mute: 'rgba(255,36,36,0.1)',
  },
  yellow: {
    lighten: '#fb3',
    default: '#ffaa00',
    dim: 'rgba(255,170,0,0.4)',
    mute: 'rgba(255,170,0,0.1)',
  },
  orange: {
    lighten: '#0659ff',
    default: '#0046d2',
    dim: 'rgba(0,70,210,0.4)',
    mute: 'rgba(0,70,210,0.1)',
  },
  blue: {
    lighten: '#61a8f0',
    default: '#338EEB',
    dim: 'rgba(51,142,235,0.4)',
    mute: 'rgba(51,142,235,0.1)',
  },
  purple: {
    lighten: '#a778e2',
    default: '#8B4ED9',
  },
  white: {
    default: '#f3f3f3',
    dim: 'rgba(243,243,243,0.4)',
    mute: 'rgba(243,243,243,0.1)',
  },
  black: {
    default: '#151516',
    dim: 'rgba(21,21,22,0.4)',
    mute: 'rgba(21,21,22,0.1)',
  },
};

export const DarkPrometheumTheme: DefaultTheme = mapDarkTheme(colors, {
  name: 'DarkProm',

  backgroundChartUpColor: colors.green.lighten,
  backgroundChartDownColor: colors.red.lighten,
  borderColorChartUpColor: colors.green.lighten,
  borderColorChartDownColor: colors.red.lighten,

  colorTextDefaultButton: '#f3f3f3',
  colorTextDefaultButtonHover: '#f3f3f3',
  colorTextDefaultButtonFocus: '#f3f3f3',
  colorTextDefaultButtonActive: '#f3f3f3',
  colorTextDefaultButtonDisabled: 'rgba(243,243,243,0.5)',

  colorTextPositiveButton: '#151516',
  colorTextPositiveButtonHover: '#151516',
  colorTextPositiveButtonFocus: '#151516',
  colorTextPositiveButtonActive: '#151516',
  colorTextPositiveButtonDisabled: 'rgba(21,21,22,0.5)',

  colorTextNegativeButton: '#151516',
  colorTextNegativeButtonHover: '#151516',
  colorTextNegativeButtonFocus: '#151516',
  colorTextNegativeButtonActive: '#151516',
  colorTextNegativeButtonDisabled: 'rgba(21,21,22,0.5)',

  colorTextWarningButton: '#151516',
  colorTextWarningButtonHover: '#151516',
  colorTextWarningButtonFocus: '#151516',
  colorTextWarningButtonActive: '#151516',
  colorTextWarningButtonDisabled: 'rgba(21,21,22,0.5)',

  colorTextPrimaryButton: '#151516',
  colorTextPrimaryButtonHover: '#151516',
  colorTextPrimaryButtonFocus: '#151516',
  colorTextPrimaryButtonActive: '#151516',
  colorTextPrimaryButtonDisabled: 'rgba(21,21,22,0.5)',

  colorTextMutedButton: '#f3f3f3',
  colorTextMutedButtonHover: '#f3f3f3',
  colorTextMutedButtonFocus: '#f3f3f3',
  colorTextMutedButtonActive: '#f3f3f3',
  colorTextMutedButtonDisabled: 'rgba(243,243,243,0.5)',
});
